import React from "react";
import { ActivateConfirmationModal } from "./Activate";
import { BulkActionErrorModal } from "@vendor-app/app/AdminRoute/AdminSubscriptionTableRoute/components/Modals/Error";
import { PauseConfirmationModal } from "./Pause";
import { SetNextOrderDateConfirmationModal } from "./SetNextOrder";
import { OpenInNewTabConfirmationModal } from "./OpenInNewTab";
import { ViewRawSubscriptionContractModal } from "./ViewRawContract";
import { CancelConfirmationModal } from "./Cancel";

export const HomeTableModals = () => {
  return (
    <React.Fragment>
      <PauseConfirmationModal />
      <ActivateConfirmationModal />
      <BulkActionErrorModal />
      <SetNextOrderDateConfirmationModal />
      <OpenInNewTabConfirmationModal />
      <ViewRawSubscriptionContractModal />
      <CancelConfirmationModal />
    </React.Fragment>
  );
};
